export const maxWordLength = 12;
export const numberOfGuesses = 8;